import { mdiAlertCircle, mdiCheckCircle, mdiCircleOutline } from '@mdi/js';
import * as React from 'react';
import { Spinner } from '../base/spinner';
import { Variables } from '../base/variables/variables';
import { FileUploadItem, UploadStatus } from './types';
import { getUploadStatusLabel } from './upload-utils';
import * as S from './upload-progress.styles';

export interface UploadProgressItemProps {
    item: FileUploadItem;
}

const renderStatusIcon = (status: UploadStatus): React.ReactNode => {
    switch (status) {
        case 'success':
            return <S.StatusIcon path={mdiCheckCircle} $color={Variables.Colors.successful} />;
        case 'failed':
            return <S.StatusIcon path={mdiAlertCircle} $color={Variables.Colors.warning} />;
        case 'uploading':
            return <Spinner size="18px" />;
        default:
            return <S.StatusIcon path={mdiCircleOutline} $color={Variables.Colors.n50} />;
    }
};

export const UploadProgressItem: React.FC<UploadProgressItemProps> = ({ item }) => (
    <S.ItemRow>
        <S.StatusIconWrapper>{renderStatusIcon(item.status)}</S.StatusIconWrapper>
        <S.ItemContent>
            <S.ItemHeader>
                <S.ItemFileName title={item.file.name}>{item.file.name}</S.ItemFileName>
                <S.ItemStatusLabel $status={item.status}>{getUploadStatusLabel(item.status)}</S.ItemStatusLabel>
            </S.ItemHeader>
            {item.status === 'failed' && item.errorMessage && (
                <S.ItemErrorMessage>{item.errorMessage}</S.ItemErrorMessage>
            )}
        </S.ItemContent>
    </S.ItemRow>
);
